import { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown, User, CalendarClock, ArrowRight, Eye, ShieldCheck } from "lucide-react";

const STATUS_CLS = {
  current: "bg-[#D1FAE5] text-[#065F46]",
  draft: "bg-[#FEF3C7] text-[#B45309]",
  superseded: "bg-stone-100 text-stone-600",
  archived: "bg-stone-100 text-stone-500",
};

export function ContentCard({ item }) {
  const [open, setOpen] = useState(false);
  const action = item.pathways?.action;
  return (
    <div className="rounded-2xl border border-stone-200 bg-white p-5" data-testid={`content-card-${item.id}`}>
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <span className="inline-block rounded-full bg-mill-alt px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-mill-muted">{item.type}</span>
          <h4 className="mt-2 font-display text-base font-semibold text-mill-ink">{item.title}</h4>
        </div>
        <span className={`shrink-0 rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider ${STATUS_CLS[item.status] || "bg-stone-100 text-stone-600"}`}>{item.status}</span>
      </div>

      <p className="mt-2 text-sm leading-relaxed text-mill-muted">{item.summary}</p>

      <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-mill-muted">
        <span className="inline-flex items-center gap-1"><User className="h-3 w-3" /> {item.owner_role}</span>
        <span className="inline-flex items-center gap-1"><CalendarClock className="h-3 w-3" /> Reviewed {item.last_reviewed}</span>
        <span className="inline-flex items-center gap-1"><Eye className="h-3 w-3" /> {item.visibility}</span>
      </div>

      <div className="mt-3 flex flex-wrap items-center gap-3">
        {action?.route && (
          <Link to={action.route} data-testid={`content-action-${item.id}`} className="inline-flex items-center gap-1.5 text-sm font-semibold text-mill-moss hover:gap-2.5 transition-all">
            {action.label} <ArrowRight className="h-3.5 w-3.5" />
          </Link>
        )}
        <button onClick={() => setOpen((o) => !o)} data-testid={`content-inspect-${item.id}`} className="inline-flex items-center gap-1 text-xs text-mill-muted hover:text-mill-ink">
          Inspect metadata <ChevronDown className={`h-3.5 w-3.5 transition-transform ${open ? "rotate-180" : ""}`} />
        </button>
      </div>

      {open && (
        <dl className="mt-3 grid grid-cols-2 gap-x-4 gap-y-2 rounded-xl bg-mill-alt/50 p-4 text-xs" data-testid={`content-metadata-${item.id}`}>
          {[
            ["Content type", item.type],
            ["Owner role", item.owner_role],
            ["Publishing authority", item.publishing_authority],
            ["Version", item.version],
            ["Published", item.published_date],
            ["Last reviewed", item.last_reviewed],
            ["Review due", item.review_due],
            ["Audience", item.audience.join(", ")],
            ["Visibility", item.visibility],
            ["Status", item.status],
            ["Future evidence", item.future_evidence],
          ].map(([k, v]) => (
            <div key={k}>
              <dt className="text-[10px] uppercase tracking-wider text-mill-muted">{k}</dt>
              <dd className="font-medium capitalize text-mill-ink">{v}</dd>
            </div>
          ))}
          <div className="col-span-2 flex items-center gap-1.5 border-t border-stone-200 pt-2 text-[11px] text-[#B45309]">
            <ShieldCheck className="h-3.5 w-3.5" /> Future receipt option: {item.future_evidence}
          </div>
        </dl>
      )}
    </div>
  );
}
